// Browser-native dialogs. react-native-web ships Alert.alert as a no-op, so the
// shared screens route through notify() / confirmDestructive() instead.

const joinText = (title, message) => [title, message].filter(Boolean).join('\n\n');

export function notify(title, message) {
  // eslint-disable-next-line no-alert
  window.alert(joinText(title, message));
}

export function confirmDestructive(title, message, confirmLabel, onConfirm) {
  // eslint-disable-next-line no-alert
  if (window.confirm(joinText(title, message))) onConfirm();
}

export function promptText(title, current, onSubmit, opts = {}) {
  // eslint-disable-next-line no-alert
  const v = window.prompt(title, current || '');
  if (v == null) return;
  if (v.trim() || opts.allowEmpty) onSubmit(v.trim());
}
